import { useAppDispatch, useAppSelector } from '../app/hooks';
import { useEffect } from 'react';
import { initSession } from '../app/thunks/init-session';
import { SessionConfiguration } from '../services/interfaces/session.interface';
import { selectInviteToken } from '../app/slices/auth.slice';
import { selectBankRedirectMethod, selectConfiguration, selectLanguage } from '../app/slices/configuration.slice';

export const useCreateSession = () => {
	const configuration = useCreateSessionConfiguration();
	const dispatch = useAppDispatch();

	useEffect(() => {
		dispatch(initSession(configuration));
	}, []);
};

export const useCreateSessionConfiguration = (): SessionConfiguration => {
	const inviteToken = useAppSelector(selectInviteToken) as string;
	const language = useAppSelector(selectLanguage);
	const bankRedirectMethod = useAppSelector(selectBankRedirectMethod);
	const configuration = useAppSelector(selectConfiguration);
	return {
		language,
		bankRedirectMethod,
		inviteToken,
		bankIntegrationVendor: configuration.bankIntegrationVendor
	};
};
